import type { LayerInfo, LayerLibraryRow } from './types';

/**
 * `LayerInfo` built from a row alone. `dateCreated` carries through from the row when the
 * catalog supplies one (the popover hides the field when absent); the consumer
 * extends this with the live `preview` / `previewPlaceholder`. Shared default of the catalog
 * and selected tables.
 */
export function defaultLayerInfo(row: LayerLibraryRow): LayerInfo {
  return {
    name: row.name,
    description: row.description,
    source: row.source,
    lastUpdated: row.updated,
    dateCreated: row.dateCreated,
    previewPlaceholder: row.layerKind === 'image' ? 'imaging' : undefined,
    subLayers: row.subLayers,
  };
}
